module.exports = __webpack_public_path__ + "static/media/logoStore_white.3affb3ee.png";